

const RoleTierTableRows = ({ rowsData, handleChange, handleChangeActive }) => {
  
  if (rowsData != "")
    return rowsData.map((data, index) => {
      const { name,isactive} = data;
    //   let splitValue;
    //   if (values != null || undefined || "") {
    //     splitValue = values?.split(",");
    //     if (
    //       splitValue[0] != "" &&
    //       splitValue[0] != null &&
    //       splitValue[0] != undefined
    //     ) {
    //       selectedAttribute[index] = splitValue;
    //     }
    //   }

     

      return (
        <tr key={index}>
          <td >Tier{index+1}</td>
          <td>
            {/* <input type="hidden" name="id" value={ID} /> */}
            <input
              type="text"
              className="form-control form-control-sm"
              name="name"
              value={name}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <input
              type="checkbox"
              name="isactive"
              checked={isactive == 1?true:false}
              onChange={(evnt) => handleChangeActive(index, evnt)}
            />
          </td>
          {/* <td>
            <TagsInput
              value={splitValue}
              // value={splitValue[0] != '' ? splitValue : selectedAttribute.value}
              onChange={handleAttributeChange}
              placeHolder="Add New Attribute Value"
            />
          </td> */}
         
        </tr>
      );
    });
};

export default RoleTierTableRows;
